import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import PlannerCardGrid from '../atoms/planner-card/PlannerCardGrid'
import styles from './plannerListStyle.module.scss'

const PlannerGridView = () => {
	const planners = useSelector((s) => s.planner.plannerSearchList)
	return (
		<div className={styles.venderGridView}>
			<Grid container spacing={2}>
				{planners?.length > 0 &&
					planners.map((item) => (
						<Grid size={{ xs: 12, sm: 6, md: 4 }} key={item._id}>
							<PlannerCardGrid data={item} />
						</Grid>
					))}
			</Grid>
		</div>
	)
}

export default PlannerGridView
